// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__eqgE0","addWidgetButton":"Header_addWidgetButton__3RBmr","dashboardTabs":"Header_dashboardTabs__1R5Dr","active":"Header_active__2M6vQ"};